import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	tooltipContent: {
		id: 'development-summary-branch.create-branch-icon-button.tooltip-content',
		defaultMessage: 'Create new branch',
		description:
			"The create new branch button tooltip content. 'Branch' is a technical term for the tool Git, and is most often not translated.",
	},
});
